"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = create;
exports.findAll = findAll;
exports.newsApi = void 0;
exports.remove = remove;
exports.update = update;
var _request = _interopRequireDefault(require("@/utils/request"));
var newsApi = {
  findAll: findAll,
  create: create,
  update: update,
  remove: remove
};
exports.newsApi = newsApi;
function findAll(listQuery) {
  return (0, _request.default)({
    url: "/v1/admin/news",
    params: listQuery
  });
}
function create(data) {
  return (0, _request.default)({
    url: "/v1/admin/news",
    method: "post",
    data: data
  });
}
function update(newsId, data) {
  return (0, _request.default)({
    url: "/v1/admin/news/".concat(newsId, "/update"),
    method: "post",
    data: data
  });
}
function remove(newsId) {
  return (0, _request.default)({
    url: "/v1/admin/news/".concat(newsId, "/delete"),
    method: "post"
  });
}